import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';

import questionActions from 'store/question/actions';
import questionSelectors from 'store/question/selectors';
import quizSelectors from 'store/quiz/selectors';
import quizActions from 'store/quiz/actions';

import TriviaQuestion from 'components/TriviaQuestion';
import PlaythroughCard from 'components/PlaythroughCard';

import { CLOUDFRONT_URL } from '../../utils';
import { QuestionContainer } from './Question.styles';
import Loadable from '../../components/Loadable';

export class Question extends Component {
  componentDidMount() {
    const {
      currentQuestion,
      getQuestion,
      selectQuestion,
      history,
      match: { params: { id } },
    } = this.props;

    // if question doesn't exist or user switch to new quiz/question, select and get question
    if (!currentQuestion || (currentQuestion && currentQuestion.id !== Number(id))) {
      selectQuestion(id);
      getQuestion(id)
        .catch(() => history.push(`/notfound`));
    }
  }

  componentDidUpdate() {
    const {
      currentQuestion,
      getQuestion,
      selectQuestion,
      history,
      quizMeta,
      getQuiz,
      getQuizResults,
      match: { params: { id } },
    } = this.props;

    // if the params in the url is a new question, you need to select and get the new question
    if (currentQuestion && currentQuestion.id !== Number(id)) {
      selectQuestion(id);
      getQuestion(id)
        .catch(() => history.push(`/notfound`));
    }
    if (!quizMeta && currentQuestion) {
      const quizId = currentQuestion.quiz;
      getQuizResults(quizId).then((response) => {
        const hasAttempted = response.data.attempted && response.data.attempted > 0;
        getQuiz(currentQuestion.quiz, hasAttempted);
      });
    }
  }

  renderQuestion = () => {
    const {
      currentQuestion,
      quiz,
      answerId,
      match: { params: { id } },
    } = this.props;

    return (
      <>
        <Helmet>
          <title>{ `${quiz ? quiz.name : currentQuestion.id}: ${currentQuestion.content}` }</title>
          <meta property="og:title" content={ currentQuestion.content } />
          <meta name="description" property="og:description" content={ `Can you answer this trivia question? ${currentQuestion.content}` } />
          <meta property="og:image" content={ `${CLOUDFRONT_URL}/qh_question_sharing.jpeg` } />
          <meta property="og:url" content={ `https://www.quizhive.com/question/${currentQuestion.id}` } />
        </Helmet>
        <TriviaQuestion
          question={currentQuestion}
          id={Number(id)}
          answerId={answerId}
        />
      </>
    );
  }

  render() {
    const {
      currentQuestion,
    } = this.props;

    return (
      <QuestionContainer>
        <PlaythroughCard>
          <Loadable ready={!!currentQuestion} renderFunc={() => (this.renderQuestion())} />
        </PlaythroughCard>
      </QuestionContainer>
    );
  }
}

Question.propTypes = {
  currentQuestion: PropTypes.object,
  quiz: PropTypes.object,
  selectQuestion: PropTypes.func,
  getQuestion: PropTypes.func,
  answerId: PropTypes.string,
  match: PropTypes.object.isRequired,
  history: PropTypes.object,
  getQuiz: PropTypes.func,
  getQuizResults: PropTypes.func,
  quizMeta: PropTypes.object,
};

export default connect((state) => {
  return {
    currentQuestion: questionSelectors.selectedQuestion(state),
    quiz: quizSelectors.selectedQuiz(state),
    answerId: state.extra.params.answerId,
    quizMeta: quizSelectors.selectedQuizMeta(state),
  };
}, {
  getQuestion: questionActions.getQuestion,
  selectQuestion: questionActions.selectQuestion,
  getQuiz: quizActions.getQuiz,
  getQuizResults: quizActions.getQuizResults,
})(withRouter(Question));
